import '@backstage/cli/asset-types';
import './backstage-ui-base.css';
import './backstage-ui-overrides.css';
import { default as React } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
